// Detect if the user is on a mobile PHONE (not tablet)
// Returns true for phones, false for tablets/desktops/laptops

export function isMobileDevice(): boolean {
  const ua = navigator.userAgent;

  // Block all iPhones and iPods (but NOT iPads)
  if (/iPhone|iPod/i.test(ua)) {
    return true;
  }

  // Block Android PHONES (have both "Android" and "Mobile" in UA)
  // Android tablets only have "Android" without "Mobile"
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) {
    return true;
  }

  // Block other mobile phones
  if (/BlackBerry|IEMobile|Opera Mini|webOS/i.test(ua)) {
    return true;
  }

  // Fallback: block very small screens (likely phones, not tablets)
  // Tablets are typically 768px+ in width
  if (window.innerWidth < 600) {
    return true;
  }

  return false;
}
